// extracted by mini-css-extract-plugin
export default {"root":"Ipzq0QIZrtn5G7AHhd6Gvg=="};